import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	close: {
		id: 'cross-flow-onboarding-modal.controls.close',
		defaultMessage: 'Close',
		description: 'Button text to close the onboarding modal',
	},
	getStarted: {
		id: 'cross-flow-onboarding-modal.controls.get-started',
		defaultMessage: 'Get started',
		description: 'Button text to begin the onboarding flow',
	},
	back: {
		id: 'cross-flow-onboarding-modal.controls.back',
		defaultMessage: 'Back',
		description: 'Button text to go back to the previous step',
	},
});
